import { createOptions } from '@atlassian/jira-project-directories-components/src/common/rest';

import type { EditableComponent } from '../../common/model';
import { getBaseUrl } from '../context/selectors';
import { getErrorFromResultJson } from '../errors';
import type { State } from '../reducer';
import { getEditedComponent, getId as getEditedId } from '../ui/edit/selectors';

import { componentEndpointUrl } from './index';

type UpdateComponent = (state: State) => Promise<EditableComponent | undefined>;

export const getComponentDataForRequest = (component?: EditableComponent) => {
	if (!component) return {};

	const { name, lead, defaultAssignee, description = '' } = component;

	return {
		name,
		description,
		assigneeType: defaultAssignee,
		leadAccountId: (lead && lead.accountId) || '',
	};
};

export const updateComponent: UpdateComponent = async (state) => {
	const componentId: string = getEditedId(state);
	const component: EditableComponent | undefined = getEditedComponent(state);
	const componentDataForRequest = getComponentDataForRequest(component);
	const fullUrl = `${getBaseUrl(state)}${componentEndpointUrl(componentId)}`;

	const result = await fetch(fullUrl, createOptions('PUT', componentDataForRequest));
	const resultJson = await result.json();

	if (result.ok) {
		return component;
	}
	throw getErrorFromResultJson(resultJson, result.status);
};
